<script>
export default {
  methods: {
    getUserFirstName(fullName) {
      return this.splitFullName(fullName)[0]
    },
    getUserLastName(fullName) {
      return this.splitFullName(fullName)[1]
    },
    splitFullName(fullName) {
      return fullName.split(/ (.+)/)
    },
  },
}
</script>
